import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { ArrowRight, Linkedin, Youtube, Twitter } from "lucide-react";
import { SiteLogo } from "@/components/SiteNav";
import { useLang } from "@/i18n";

const RED = "#c00000";
const O = { fontFamily: "Outfit, sans-serif" };

const COLS = [
  { de: "Produkt", en: "Product", items: [["Übersicht", "Overview", "/produkte"], ["Funktionen", "Features", "/produkte"], ["Preise", "Pricing", "/preise"], ["Login", "Sign in", "/login"]] },
  { de: "Lösungen", en: "Solutions", items: [["Flottenmanagement", "Fleet management", "/loesungen"], ["IT-Asset-Management", "IT asset management", "/loesungen"], ["Maschinen-Monitoring", "Machine monitoring", "/loesungen"], ["Branchen", "Industries", "/branchen"]] },
  { de: "Ressourcen", en: "Resources", items: [["Blog", "Blog", "/ressourcen"], ["Case Studies", "Case studies", "/ressourcen"], ["Whitepapers", "Whitepapers", "/ressourcen"], ["Hilfe-Center", "Help center", "/ressourcen"]] },
  { de: "Unternehmen", en: "Company", items: [["Über uns", "About", "/ressourcen"], ["Karriere", "Careers", "/ressourcen"], ["News", "News", "/ressourcen"], ["Kontakt", "Contact", "/kontakt"]] },
];

export default function SiteFooter() {
  const navigate = useNavigate();
  const { lang } = useLang();
  const de = lang === "de";
  return (
    <footer className="text-gray-400 px-4 sm:px-6 py-12" style={{ background: "#0f1115" }}>
      <div className="max-w-7xl mx-auto grid sm:grid-cols-2 lg:grid-cols-5 gap-8">
        <div className="lg:col-span-1">
          <Link to="/"><SiteLogo dark /></Link>
          <p className="text-xs text-gray-500 mt-3 mb-4">{de ? "Alle Assets. Ein besseres Morgen." : "All assets. A better tomorrow."}</p>
          <button onClick={() => navigate("/kontakt")} className="inline-flex items-center gap-1.5 text-white text-sm font-semibold rounded-lg px-4 py-2 hover:brightness-110 hover:-translate-y-0.5 transition-all" style={{ background: RED }}>{de ? "Demo anfragen" : "Request demo"} <ArrowRight className="w-4 h-4" /></button>
        </div>
        {COLS.map((col) => (
          <div key={col.de}>
            <div className="text-white font-semibold text-sm mb-3" style={O}>{de ? col.de : col.en}</div>
            <ul className="space-y-2 text-sm">
              {col.items.map(([d, e, path], i) => (
                <li key={i}><button onClick={() => navigate(path)} className="hover:text-white transition-colors">{de ? d : e}</button></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="max-w-7xl mx-auto mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-gray-500">
        <div className="flex items-center gap-4"><span className="font-mono">© 2026 FleetArea</span><span className="hover:text-gray-300 transition-colors cursor-pointer">{de ? "Datenschutz" : "Privacy"}</span><span className="hover:text-gray-300 transition-colors cursor-pointer">{de ? "AGB" : "Terms"}</span><span className="hover:text-gray-300 transition-colors cursor-pointer">Cookies</span></div>
        <div className="flex items-center gap-3">
          <Linkedin className="w-4 h-4 hover:text-white transition-colors cursor-pointer" />
          <Youtube className="w-4 h-4 hover:text-white transition-colors cursor-pointer" />
          <Twitter className="w-4 h-4 hover:text-white transition-colors cursor-pointer" />
        </div>
      </div>
    </footer>
  );
}
